/** 券状态 */
export var CouponState;
(function (CouponState) {
    /** 未领取 */
    CouponState["notReceived"] = "0";
    /** 已领取 */
    CouponState["received"] = "1";
    /** 已使用 */
    CouponState["used"] = "2";
    /** 已过期 */
    CouponState["expired"] = "3";
})(CouponState || (CouponState = {}));
/** 券使用状态 */
export var TransState;
(function (TransState) {
    /** 1-初始，未使用 */
    TransState[TransState["NOT_USED"] = 1] = "NOT_USED";
    /** 2-已使用 */
    TransState[TransState["USED"] = 2] = "USED";
    /** 3-过期作废 */
    TransState[TransState["NOT_USED_EXPIRED"] = 3] = "NOT_USED_EXPIRED";
    /** 4-已退款（部分退款）*/
    TransState[TransState["REFUND"] = 4] = "REFUND";
})(TransState || (TransState = {}));
/** 券过期状态 */
export var ExpireState;
(function (ExpireState) {
    /** 未过期 */
    ExpireState[ExpireState["NOT_EXPIRED"] = 0] = "NOT_EXPIRED";
    /** 已过期 */
    ExpireState[ExpireState["EXPIRED"] = 1] = "EXPIRED";
})(ExpireState || (ExpireState = {}));
/** 券状态 + 活动状态 */
export var ActivityCouponState;
(function (ActivityCouponState) {
    /** 未领取 */
    ActivityCouponState["notReceived"] = "notReceived";
    /** 已领取 */
    ActivityCouponState["received"] = "received";
    /** 已使用 */
    ActivityCouponState["used"] = "used";
    /** 已过期 */
    ActivityCouponState["expired"] = "expired";
    /** 未开始 */
    ActivityCouponState["notStarted"] = "notStarted";
    /** 可兑换，展示库存 */
    ActivityCouponState["avaliable"] = "avaliable";
    /** 奖品维度-今日已领完 */
    ActivityCouponState["dayLimit"] = "dayLimit";
    /** 奖品维度-券已售罄 */
    ActivityCouponState["totalLimit"] = "totalLimit";
    /** 用户维度-月限额 */
    ActivityCouponState["monthUserLimit"] = "monthUserLimit";
    /** 用户维度-总限额 */
    ActivityCouponState["totalUserLmit"] = "totalUserLmit";
    /** 印花不足 */
    ActivityCouponState["qualNoEnough"] = "qualNoEnough";
})(ActivityCouponState || (ActivityCouponState = {}));
/** 优惠券类型 */
export var CouponType;
(function (CouponType) {
    /** 固定金额优惠券 */
    CouponType[CouponType["FIXED"] = 1] = "FIXED";
    /** 折扣优惠券 */
    CouponType[CouponType["DISC"] = 2] = "DISC";
    /** 变金额优惠券 */
    CouponType[CouponType["FLOATING"] = 3] = "FLOATING";
    /** 消费券 */
    CouponType[CouponType["GOV_CV"] = 4001] = "GOV_CV";
    /** 平台券 */
    CouponType[CouponType["PT_CV"] = 4002] = "PT_CV";
    /** 无CDKEY关联商家展示券 */
    CouponType[CouponType["SPCOUOPN"] = 5001] = "SPCOUOPN";
    /** 不同CDKEY商家展示券 */
    CouponType[CouponType["SPCOUOPN_CDKEY"] = 5002] = "SPCOUOPN_CDKEY";
    /** 相同CDKEY商家展示券 */
    CouponType[CouponType["SPCOUOPN_ONECDKEY"] = 5003] = "SPCOUOPN_ONECDKEY";
})(CouponType || (CouponType = {}));
/** 券过期类型 */
export var ExpireType;
(function (ExpireType) {
    /** 1 –  有效期为固定时间 */
    ExpireType[ExpireType["FIXED"] = 1] = "FIXED";
    /** 2 –  有效期为相对时间，如7天后过期 */
    ExpireType[ExpireType["CHANGE"] = 2] = "CHANGE";
})(ExpireType || (ExpireType = {}));
/** CP-优惠券-交易状态 */
export var UserCouponTransState;
(function (UserCouponTransState) {
    /** 待使用 */
    UserCouponTransState["UNUSED"] = "1";
    /** 已使用 */
    UserCouponTransState["USED"] = "2";
    /** 过期作废 */
    UserCouponTransState["EXPIRED"] = "3";
    /** 已退款（部分退款） */
    UserCouponTransState["REFUND"] = "4";
    /** 预使用 */
    UserCouponTransState["PREUSED"] = "5";
})(UserCouponTransState || (UserCouponTransState = {}));
/** SP-商户展示券-交易状态 */
export var UserSPCouponTransState;
(function (UserSPCouponTransState) {
    /** 待使用 */
    UserSPCouponTransState["UNUSED"] = "1";
    /** 已使用 */
    UserSPCouponTransState["USED"] = "2";
    /** 已打开 */
    UserSPCouponTransState["OPENED"] = "3";
    /** 过期作废 */
    UserSPCouponTransState["EXPIRED"] = "4";
})(UserSPCouponTransState || (UserSPCouponTransState = {}));
/** CV-消费券-交易状态 */
export var UserCVCouponTransState;
(function (UserCVCouponTransState) {
    /** 初始状态 */
    UserCVCouponTransState["INITAIL"] = "1";
    /** 转移 / 转增中 */
    UserCVCouponTransState["TRANSFERRING"] = "2";
    /** 转移 / 转增完成 */
    UserCVCouponTransState["TRANSFERRED"] = "3";
})(UserCVCouponTransState || (UserCVCouponTransState = {}));
/** SP-商户展示券-优惠券信息 */
export var UserCouponSpType;
(function (UserCouponSpType) {
    /** 5001-商户展示券（普通） */
    UserCouponSpType["NO_CDKEY"] = "5001";
    /** 5002-商户展示券（用户CDKEY不同） */
    UserCouponSpType["CDKEY"] = "5002";
    /** 5003-商户展示券（单CDKEY） */
    UserCouponSpType["SINGLE_CDKEY"] = "5003";
})(UserCouponSpType || (UserCouponSpType = {}));
/** CV-消费券-优惠券信息 */
export var UserCouponCvType;
(function (UserCouponCvType) {
    /** 政府消费券 */
    UserCouponCvType["GOVERNMENT"] = "4001";
    /** 平台消费券 */
    UserCouponCvType["PLATFORM"] = "4002";
})(UserCouponCvType || (UserCouponCvType = {}));
